
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCenterOffIec as ObiCenterOffIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-center-off-iec.js';
 
 
 

 
 export const ObiCenterOffIec = createComponent({
   react: React,
   tagName: 'obi-center-off-iec',
   elementClass: ObiCenterOffIecElement,
   events: {
     
   }
  });
 
 